import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";

export const IconButtonBg = ({ onClick, className, children }) => (
    <IconButton
        className={className || ""}
        onClick={onClick}
        aria-label="Menu"
    >
        { children }
    </IconButton>
);

IconButtonBg.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};
